module.exports = __webpack_public_path__ + "star.png?704a73f522715d87ba3cc3f1697ec638";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star.png
// module id = 325
// module chunks = 0